import React, { useContext, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { AppLocale } from 'constant';

import logo from 'assets/logo-black.svg';

import AutenticateButton from 'components/AutenticateButton';
import Menu from 'components/Menu';

import { LanguageContext } from 'context/languageContext';

import {
  Wrapper,
  LogoWrapper,
  LinkStyled,
  Logo,
  SubTitle,
  StyledContainer,
  SideBar,
  LangList,
  LangItem,
  LangButton,
  HamburgerMenuButton,
  HamburgerMenu,
  PageName
} from './Header.styles';

export interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const intl = useIntl();
  const { locale, changeLanguage } = useContext(LanguageContext);
  const closeButtonRef = useRef<HTMLDivElement>(null);

  const [showMenu, setShowMenu] = useState(false);

  return (
    <React.Fragment>
      <Wrapper className={className}>
        <StyledContainer>
          <LogoWrapper>
            <LinkStyled to="/">
              <PageName>
                Fans 4
              </PageName>
              <Logo src={logo} alt="ONE OK ROCK Logo" />
            </LinkStyled>
            <SubTitle>{intl.formatMessage({ id: 'header.title' })}</SubTitle>
          </LogoWrapper>
          <SideBar>
            <LangList>
              <LangItem>
                <LangButton active={locale === AppLocale.JP} onClick={() => changeLanguage(AppLocale.JP)}>
                  JP
                </LangButton>
              </LangItem>
              <LangItem>
                <LangButton active={locale === AppLocale.EN} onClick={() => changeLanguage(AppLocale.EN)}>
                  EN
                </LangButton>
              </LangItem>
            </LangList>
            <AutenticateButton mobileShow={false} />
          </SideBar>
          <HamburgerMenuButton
            showMenu={showMenu}
            onClick={() => setShowMenu(!showMenu)}
          >
            <HamburgerMenu showMenu={showMenu} ref={closeButtonRef} />
          </HamburgerMenuButton>
        </StyledContainer>
      </Wrapper>
      <Menu showMenu={showMenu} setShowMenu={setShowMenu} closeButtonRef={closeButtonRef} />
    </React.Fragment>
  );
};

export default Header;
